import React from "react";
import { Image } from "spectacle";
import thanks from "./thanks.gif";

export const S90 = () => <Image src={thanks} />;
